module.exports = __webpack_public_path__ + "img/bind_order.5065bc59.png";